import type { AccentHue } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import { type JSX, type ParentProps, Show, splitProps } from "solid-js"
import { Icon } from "./icon"
import { badgeRecipe, clampClass, iconRecipe, linkRecipe } from "./nav-link.css"

type LinkProps = ParentProps &
  JSX.AnchorHTMLAttributes<HTMLAnchorElement> & {
    hue: AccentHue
    wrap?: boolean
    iconName?: IconName
    badge?: number
  }
export function NavLink(props: LinkProps) {
  const [_, otherProps] = splitProps(props, ["hue", "iconName", "badge"])

  return (
    <a class={linkRecipe({ hue: props.hue, wrap: props.wrap })} {...otherProps}>
      <Show when={props.iconName}>
        {iconName => (
          <Icon
            name={iconName()}
            class={iconRecipe({ hue: props.hue })}
            size="18"
          />
        )}
      </Show>
      <span class={clampClass}>{otherProps.children}</span>
      <Show when={props.badge && props.badge > 0}>
        <span class={badgeRecipe({ hue: props.hue })}>{props.badge}</span>
      </Show>
    </a>
  )
}
